export const FETCH_CARDS = 'FETCH_CARDS'
export const SET_CARDS = 'SET_CARDS'
export const ADD_DECK = 'ADD_DECK'
export const TOGGLE_LOADING = 'TOGGLE_LOADING'
export const SET_ERROR = 'SET_ERROR'